import currency from 'currency.js';

export const itemTax = (itemPrice, itemPromotionValue, taxRate) => {
  return productTax(currency(itemPrice).subtract(itemPromotionValue).value, taxRate).tax;
};

export const productTax = (price, taxRate) => {
  const tax = currency(price).multiply(taxRate || 0).divide(100);
  return {
    tax: tax.value,
    price: currency(price).add(tax).value,
  };
};

export const getSalesTaxDiff = (itemsTaxes, totalAmount, subtotalAmount) => {
  const totalTax = currency(totalAmount).subtract(subtotalAmount);
  const totalItemsTax = itemsTaxes.reduce((acc, salesTax) => acc.add(salesTax), currency(0));
  return totalTax.subtract(totalItemsTax).value;
};
